function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46588",
    d: "M33.756 3.949a4.393 4.393 0 0 0 4.494 0l3.264-2.18a2.628 2.628 0 0 1 3.69.79l2.1 3.329a4.4 4.4 0 0 0 4.1 1.836l3.865-.658a2.637 2.637 0 0 1 3.052 2.229l.573 3.892a4.428 4.428 0 0 0 3.006 3.36l3.793.983a2.658 2.658 0 0 1 1.887 3.29l-1.047 3.78a4.447 4.447 0 0 0 1.387 4.3L71 31.356a2.662 2.662 0 0 1 .393 3.774l-2.5 3.033a4.45 4.45 0 0 0-.47 4.492l1.815 3.488a2.659 2.659 0 0 1-1.166 3.609L65.561 51.5a4.436 4.436 0 0 0-2.246 3.912l.243 3.929a2.649 2.649 0 0 1-2.527 2.821l-3.914.167a4.415 4.415 0 0 0-3.635 2.658l-1.362 3.687a2.635 2.635 0 0 1-3.449 1.546l-3.646-1.449a4.389 4.389 0 0 0-4.395.939l-2.739 2.812a2.632 2.632 0 0 1-3.776 0l-2.743-2.814a4.395 4.395 0 0 0-4.4-.938l-3.645 1.449a2.633 2.633 0 0 1-3.448-1.546l-1.361-3.683a4.414 4.414 0 0 0-3.635-2.658l-3.912-.167a2.65 2.65 0 0 1-2.527-2.821l.245-3.929A4.44 4.44 0 0 0 6.441 51.5l-3.51-1.752a2.659 2.659 0 0 1-1.166-3.609l1.815-3.488a4.444 4.444 0 0 0-.471-4.49l-2.5-3.037A2.66 2.66 0 0 1 1 31.355L4.081 28.9a4.448 4.448 0 0 0 1.388-4.3l-1.053-3.782A2.654 2.654 0 0 1 6.3 17.531l3.8-.985a4.427 4.427 0 0 0 3.006-3.36l.573-3.892a2.638 2.638 0 0 1 3.053-2.229l3.865.658a4.393 4.393 0 0 0 4.1-1.836l2.1-3.329a2.629 2.629 0 0 1 3.691-.79z",
    transform: "translate(0 -1.324)",
    style: {
      fill: "#4fb589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46589",
    d: "M136.943 114.067a23.295 23.295 0 1 1-23.295-23.412 23.356 23.356 0 0 1 23.295 23.412z",
    transform: "translate(-77.649 -78.028)",
    style: {
      fill: "#4fb589"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46590",
    d: "m171.4 210.3-9.324-9.373 3.106-3.124 6.218 6.249 13.985-14.06 3.106 3.125z",
    transform: "translate(-139.286 -163.326)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.7ce6152d92fa87239d08a14d2c3f34bb.svg";
export { ForwardRef as ReactComponent };